import PropTypes from 'prop-types';
import { Box } from '@mui/material';

export default function BookingModeToggle({ useDentally, onChange }) {
  const CHIP = (isActive) => ({
    display: 'inline-flex', alignItems: 'center',
    px: 1.5, py: 0.5, borderRadius: '10px',
    fontSize: '12px', fontWeight: 600, cursor: 'pointer',
    border: '1px solid', transition: 'all 150ms ease',
    ...(isActive
      ? { borderColor: '#00AB55', color: '#00AB55', background: 'rgba(0,171,85,0.06)' }
      : { borderColor: '#e0e0e0', color: '#637381', background: 'transparent', '&:hover': { borderColor: '#919EAB', background: '#fafafa' } }),
  });

  return (
    <Box sx={{ display: 'flex', gap: 0.75, px: 3, pt: 2, mb: 1 }}>
      <Box onClick={() => onChange(true)} sx={CHIP(useDentally)}>Dentally</Box>
      <Box onClick={() => onChange(false)} sx={CHIP(!useDentally)}>CRM</Box>
    </Box>
  );
}

BookingModeToggle.propTypes = {
  useDentally: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
